import React, { createContext, useState } from "react";

type EmailChecklistItem = {
  send_self: boolean;
  signature_digital: boolean;
  order: number;
};

type EmailChecklistType = {
  [email: string]: EmailChecklistItem;
};

type EmailChecklistContextType = {
  emailChecklist: EmailChecklistType;
  setEmailChecklist: React.Dispatch<React.SetStateAction<EmailChecklistType>>;
};

export const EmailChecklistContext = createContext<EmailChecklistContextType>({
  emailChecklist: {},
  setEmailChecklist: () => {},
});

export function EmailChecklistProvider(props: { children: React.ReactNode }) {
  const [emailChecklist, setEmailChecklist] = useState<EmailChecklistType>({});

  return (
    <EmailChecklistContext.Provider
      value={{ emailChecklist, setEmailChecklist }}
    >
      {props.children}
    </EmailChecklistContext.Provider>
  );
}
